import { render } from "./listRma.vue?vue&type=template&id=64897680&scoped=true"
import script from "./listRma.vue?vue&type=script&lang=js"
export * from "./listRma.vue?vue&type=script&lang=js"

import "./listRma.vue?vue&type=style&index=0&id=64897680&scoped=true&lang=scss"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64897680"]])

export default __exports__